export var DTParsedThemeSetPriority;
(function (DTParsedThemeSetPriority) {
    DTParsedThemeSetPriority["source"] = "source";
    DTParsedThemeSetPriority["enabled"] = "enabled";
    DTParsedThemeSetPriority["disabled"] = "disabled";
})(DTParsedThemeSetPriority || (DTParsedThemeSetPriority = {}));
